// import case names
import * as CASE_NAMES from './externalLinksResolver.constants';

import { get, noop } from 'lodash';

import { overlay } from 'modules/overlay';
import { OVERLAY_VIEWS } from 'constants/templates';

/**
 * @type {function}
 * @desc Resolvers are pure functions used for resolving templates (React components) or to transform some data.
 * A resolver function takes an `id` and an optional `payload` and returns a `result`.
 * Based on `switch` cases inside this function, correct `result` should be returned.
 * @param {object} payload
 * @example
 * import { externalLinksResolverResolver } from 'resolvers/externalLinksResolver';
 */
export const externalLinksResolverResolver = ( { name = '', config, props = {} } ) => {
    log.debug( 'externalLinksResolverResolver' );

    switch( name ) {

        // sample case
        case CASE_NAMES.MANUAL_ENROLLMENT_SERVICE_NOW: {

            return overlay.open( {
                settings: {
                    modalType: OVERLAY_VIEWS.SERVICE_NOW_FORM,
                    showCloseButton: false,
                    ignoreOutsideClick: true,
                },
                data: {
                    ...props,
                    ...config,
                    requestData: get( config, 'config', {} ),
                    title: {
                        refId: 'titleServiceNow',
                        value: ''
                    }
                }
            } );
        }

        // default case
        default: {
            return noop;
        }
    }
};
